import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const VideoTutorialCard = ({ title, duration, thumbnail, thumbnailAlt, instructor, locked = true }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-elevation-2 transition-all duration-200 group">
      <div className="relative aspect-video bg-muted overflow-hidden">
        <Image
          src={thumbnail}
          alt={thumbnailAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
          <div className="w-14 h-14 bg-primary/90 rounded-full flex items-center justify-center group-hover:bg-primary transition-colors duration-200">
            <Icon name="Play" size={24} color="var(--color-primary-foreground)" strokeWidth={2.5} />
          </div>
        </div>
        {locked && (
          <div className="absolute top-3 right-3 w-8 h-8 bg-black/60 backdrop-blur-sm rounded-full flex items-center justify-center">
            <Icon name="Lock" size={16} color="white" />
          </div>
        )}
        <div className="absolute bottom-3 right-3 bg-black/80 backdrop-blur-sm px-2 py-1 rounded text-xs text-white font-medium">
          {duration}
        </div>
      </div>
      <div className="p-4">
        <h4 className="text-sm font-semibold text-foreground mb-2 line-clamp-2">{title}</h4>
        <p className="text-xs text-muted-foreground">{instructor}</p>
      </div>
    </div>
  );
};

export default VideoTutorialCard;